module.exports = __webpack_public_path__ + "media/images/appIcon-f663309d6a646dc9eca0ddbe5858d696.png";